import React, { Component } from "react";
import {
  DatePicker,
  Spin,
  message,
  Checkbox,
  Radio,
  Space,
  Select,
  Input,
} from "antd";
import Bridge from "../../../../utils/Bridge";
import { LE_STUDY_DEMOGRAPHICS_CONTENT } from "../../../../utils/consts";
import moment from "moment";
import dayjs from "dayjs";
import { RESEARCH_TYPE } from "../../../../utils/consts";

import englishJson from "../../../../utils/language/leStudy/english.json";
import spanishJson from "../../../../utils/language/leStudy/spanish.json";
import noLanguageJson from "../../../../utils/language/leStudy/noLanguage.json";

const { Option } = Select;

export default class SymptomOnsetForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gender: "",
      loading: false,
      email: "",
      neurostamp_id: "",
      modality_id: "",
      question_list: [],
      field_data: [],

      // Commented out fields
      age_at_diagnosis: "",
      // symptom_onset_site: "",
      phenotype: "",
      genetic_status: "",
      date_of_symptom_onset: null,
      date_of_diagnosis: null,
      gene_list: "",
      date_of_birth: null,
      genetic_status_other_specification: "",

      // New Site of Symptom Onset fields
      generalized: false,
      bulbar: false,
      bulbar_speech: false,
      bulbar_swallowing: false,
      neck_weakness: false,
      trunk_weakness: false,
      respiratory: false,
      limb: false,
      limb_upper: false,
      limb_upper_right: false,
      limb_upper_right_hand_fingers: false,
      limb_upper_right_arm: false,
      limb_upper_left: false,
      limb_upper_left_hand_fingers: false,
      limb_upper_left_arm: false,
      limb_lower: false,
      limb_lower_right: false,
      limb_lower_right_ankle_foot_toes: false,
      limb_lower_right_leg: false,
      limb_lower_left: false,
      limb_lower_left_ankle_foot_toes: false,
      limb_lower_left_leg: false,
      symptom_other: false,
      symptom_other_specification: "",
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.le_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.parent_field === "Date of Birth") {
                this.setState({
                  date_of_birth: item.value ? dayjs(item.value) : null,
                });
              }
              // Commented out fields
              // if (item.parent_field === "Gene Details") {
              //   this.setState({
              //     gene_list: item.value ? JSON.parse(item.value) : [],
              //   });
              // }
              if (item.parent_field === "Age at Diagnosis") {
                this.setState({ age_at_diagnosis: item.value });
              }
              if (item.parent_field === "Date of Symptom Onset") {
                this.setState({
                  date_of_symptom_onset: item.value
                    ? dayjs(item.value, "MM/YYYY")
                    : null,
                });
              }
              if (item.parent_field === "Date of Diagnosis") {
                this.setState({
                  date_of_diagnosis: item.value
                    ? dayjs(item.value, "MM/YYYY")
                    : null,
                });
              }
              // if (item.parent_field === "Site of Onset") {
              //   this.setState({ symptom_onset_site: item.value });
              // }
              if (item.parent_field === "Phenotype") {
                this.setState({ phenotype: item.value });
              }
              if (item.parent_field === "Genetic Status") {
                this.setState({ genetic_status: item.value });
              }
              if (item.parent_field === "Gene Details") {
                this.setState({
                  gene_list: item.value ? JSON.parse(item.value) : [],
                });
              }
              if (item.field == "Gene Details Other Specification") {
                this.setState({
                  genetic_status_other_specification: item.value,
                });
              }

              // New Site of Symptom Onset fields
              if (item.field == "Generalized") {
                this.setState({
                  generalized: item.value == "1" ? true : false,
                });
              }
              if (item.field == "Bulbar") {
                this.setState({ bulbar: item.value == "1" ? true : false });
              }
              if (item.field == "Bulbar Speech") {
                this.setState({
                  bulbar_speech: item.value == "1" ? true : false,
                });
              }
              if (item.field == "Bulbar Swallowing") {
                this.setState({
                  bulbar_swallowing: item.value == "1" ? true : false,
                });
              }
              if (item.field == "Neck Weakness") {
                this.setState({
                  neck_weakness: item.value == "1" ? true : false,
                });
              }
              if (item.field == "Trunk Weakness") {
                this.setState({
                  trunk_weakness: item.value == "1" ? true : false,
                });
              }
              if (item.field == "Respiratory") {
                this.setState({
                  respiratory: item.value == "1" ? true : false,
                });
              }
              if (item.field == "Limb") {
                this.setState({ limb: item.value == "1" ? true : false });
              }
              if (item.field == "Limb Upper") {
                this.setState({ limb_upper: item.value == "1" ? true : false });
              }
              if (item.field == "Limb Upper Right") {
                this.setState({
                  limb_upper_right: item.value == "1" ? true : false,
                });
              }
              if (item.field == "Limb Upper Right Hand Fingers") {
                this.setState({
                  limb_upper_right_hand_fingers:
                    item.value == "1" ? true : false,
                });
              }
              if (item.field == "Limb Upper Right Arm") {
                this.setState({
                  limb_upper_right_arm: item.value == "1" ? true : false,
                });
              }
              if (item.field == "Limb Upper Left") {
                this.setState({
                  limb_upper_left: item.value == "1" ? true : false,
                });
              }
              if (item.field == "Limb Upper Left Hand Fingers") {
                this.setState({
                  limb_upper_left_hand_fingers:
                    item.value == "1" ? true : false,
                });
              }
              if (item.field == "Limb Upper Left Arm") {
                this.setState({
                  limb_upper_left_arm: item.value == "1" ? true : false,
                });
              }
              if (item.field == "Limb Lower") {
                this.setState({ limb_lower: item.value == "1" ? true : false });
              }
              if (item.field == "Limb Lower Right") {
                this.setState({
                  limb_lower_right: item.value == "1" ? true : false,
                });
              }
              if (item.field == "Limb Lower Right Ankle Foot Toes") {
                this.setState({
                  limb_lower_right_ankle_foot_toes:
                    item.value == "1" ? true : false,
                });
              }
              if (item.field == "Limb Lower Right Leg") {
                this.setState({
                  limb_lower_right_leg: item.value == "1" ? true : false,
                });
              }
              if (item.field == "Limb Lower Left") {
                this.setState({
                  limb_lower_left: item.value == "1" ? true : false,
                });
              }
              if (item.field == "Limb Lower Left Ankle Foot Toes") {
                this.setState({
                  limb_lower_left_ankle_foot_toes:
                    item.value == "1" ? true : false,
                });
              }
              if (item.field == "Limb Lower Left Leg") {
                this.setState({
                  limb_lower_left_leg: item.value == "1" ? true : false,
                });
              }
              if (item.field == "Other") {
                this.setState({
                  symptom_other: item.value == "1" ? true : false,
                });
              }
              if (item.field == "Other Specification") {
                this.setState({ symptom_other_specification: item.value });
              }
            }
          }
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  onChange = (date, dateString) => {
    this.setState({
      date_of_symptom_onset: date,
    });
  };
  // goToNextStep: true = Save & Next (validate + navigate), false = Save for later (no validation, redirect)
  save = (goToNextStep = true) => {
    const {
      generalized,
      bulbar,
      bulbar_speech,
      bulbar_swallowing,
      neck_weakness,
      trunk_weakness,
      respiratory,
      limb,
      limb_upper,
      limb_upper_right,
      limb_upper_right_hand_fingers,
      limb_upper_right_arm,
      limb_upper_left,
      limb_upper_left_hand_fingers,
      limb_upper_left_arm,
      limb_lower,
      limb_lower_right,
      limb_lower_right_ankle_foot_toes,
      limb_lower_right_leg,
      limb_lower_left,
      limb_lower_left_ankle_foot_toes,
      limb_lower_left_leg,
      symptom_other,
    } = this.state;

    const formData =
      RESEARCH_TYPE === "LE Study"
        ? this.props.language === "English"
          ? englishJson
          : this.props.language === "Spanish"
            ? spanishJson
            : noLanguageJson
        : englishJson;

    // Validation only for Save & Next
    if (goToNextStep) {
      const isSiteOfSymptomOnsetSelected =
        generalized ||
        bulbar ||
        bulbar_speech ||
        bulbar_swallowing ||
        neck_weakness ||
        trunk_weakness ||
        respiratory ||
        limb ||
        limb_upper ||
        limb_upper_right ||
        limb_upper_right_hand_fingers ||
        limb_upper_right_arm ||
        limb_upper_left ||
        limb_upper_left_hand_fingers ||
        limb_upper_left_arm ||
        limb_lower ||
        limb_lower_right ||
        limb_lower_right_ankle_foot_toes ||
        limb_lower_right_leg ||
        limb_lower_left ||
        limb_lower_left_ankle_foot_toes ||
        limb_lower_left_leg ||
        symptom_other;

      if (!isSiteOfSymptomOnsetSelected) {
        message.warning(formData.page.demographicQuestions.messages.validation.siteOfSymptomOnsetRequired);
        return;
      }
      if (!this.state.phenotype) {
        message.warning(formData.page.demographicQuestions.messages.validation.phenotypeRequired);
        return;
      }
      if (!this.state.genetic_status) {
        message.warning(formData.page.demographicQuestions.messages.validation.geneticStatusRequired);
        return;
      }
      if (
        this.state.genetic_status === "Positive" &&
        this.state.gene_list.length == 0
      ) {
        message.warning(formData.page.demographicQuestions.messages.validation.geneListRequired);
        return;
      }
      if (!this.state.date_of_diagnosis) {
        message.warning(formData.page.demographicQuestions.messages.validation.dateOfDiagnosisRequired);
        return;
      }
      if (!this.state.age_at_diagnosis) {
        message.warning(formData.page.demographicQuestions.messages.validation.ageAtDiagnosisRequired);
        return;
      }
      if (!this.state.date_of_symptom_onset) {
        message.warning(formData.page.demographicQuestions.messages.validation.dateOfSymptomOnsetRequired);
        return;
      }
    }

    // Check if all mandatory Symptom Onset fields are present (1 = complete, 0 = incomplete)
    const isSiteOfSymptomOnsetSelected =
      generalized ||
      bulbar ||
      bulbar_speech ||
      bulbar_swallowing ||
      neck_weakness ||
      trunk_weakness ||
      respiratory ||
      limb ||
      limb_upper ||
      limb_upper_right ||
      limb_upper_right_hand_fingers ||
      limb_upper_right_arm ||
      limb_upper_left ||
      limb_upper_left_hand_fingers ||
      limb_upper_left_arm ||
      limb_lower ||
      limb_lower_right ||
      limb_lower_right_ankle_foot_toes ||
      limb_lower_right_leg ||
      limb_lower_left ||
      limb_lower_left_ankle_foot_toes ||
      limb_lower_left_leg ||
      symptom_other;
    const isSymptomOnsetComplete =
      isSiteOfSymptomOnsetSelected &&
      this.state.phenotype &&
      this.state.genetic_status &&
      (this.state.genetic_status !== "Positive" || (this.state.gene_list && this.state.gene_list.length > 0)) &&
      this.state.date_of_diagnosis &&
      this.state.age_at_diagnosis &&
      this.state.date_of_symptom_onset
        ? 1
        : 0;

    // step 2
    const saveForLater = !goToNextStep;
    let questions = [
      ...(saveForLater
        ? [
            {
              parent_field: "Save",
              field: "Save for later date",
              value: dayjs().format("MM/DD/YYYY HH:mm"),
            },
          ]
        : []),
      {
        parent_field: "Form Save Type",
        field: "Form Save Type",
        value: saveForLater ? "Save for Later" : "Save Demographics",
      },
      {
        parent_field: "Symptom Onset",
        field: "Symptom Onset",
        value: isSymptomOnsetComplete,
      },
      // Commented out fields
      {
        parent_field: "Age at Diagnosis",
        field: "Age at Diagnosis",
        value: this.state.age_at_diagnosis,
      },
      {
        parent_field: "Date of Symptom Onset",
        field: "Date of Symptom Onset",
        value: this.state.date_of_symptom_onset
          ? dayjs(this.state.date_of_symptom_onset).format("MM/YYYY")
          : "",
      },
      {
        parent_field: "Date of Diagnosis",
        field: "Date of Diagnosis",
        value: this.state.date_of_diagnosis
          ? dayjs(this.state.date_of_diagnosis).format("MM/YYYY")
          : "",
      },
      // {
      //   parent_field: "Site of Onset",
      //   field: "Site of Onset",
      //   value: this.state.symptom_onset_site,
      //   subId:
      //     LE_STUDY_DEMOGRAPHICS_CONTENT.find(
      //       (item) => item.field == "siteOfOnset"
      //     )?.content.find(
      //       (item) => item.subtitle == this.state.symptom_onset_site
      //     )?.subId || "",
      // },
      {
        parent_field: "Phenotype",
        field: "Phenotype",
        value: this.state.phenotype,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "phenotype"
          )?.content.find((item) => item.subtitle == this.state.phenotype)
            ?.subId || "",
      },
      {
        parent_field: "Genetic Status",
        field: "Genetic Status",
        value: this.state.genetic_status,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "geneticStatus"
          )?.content.find((item) => item.subtitle == this.state.genetic_status)
            ?.subId || "",
      },
      {
        parent_field: "Gene Details",
        field: "Gene Details",
        value: this.state.gene_list ? JSON.stringify(this.state.gene_list) : "",
      },
      {
        parent_field: "Gene Details Other Specification",
        field: "Gene Details Other Specification",
        value: this.state.genetic_status_other_specification,
      },

      // New Site of Symptom Onset fields
      {
        parent_field: "Site of Onset",
        field: "Generalized",
        value: this.state.generalized ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Bulbar",
        value: this.state.bulbar ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Bulbar Speech",
        value: this.state.bulbar_speech ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Bulbar Swallowing",
        value: this.state.bulbar_swallowing ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Neck Weakness",
        value: this.state.neck_weakness ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Trunk Weakness",
        value: this.state.trunk_weakness ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Respiratory",
        value: this.state.respiratory ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb",
        value: this.state.limb ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Upper",
        value: this.state.limb_upper ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Upper Right",
        value: this.state.limb_upper_right ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Upper Right Hand Fingers",
        value: this.state.limb_upper_right_hand_fingers ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Upper Right Arm",
        value: this.state.limb_upper_right_arm ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Upper Left",
        value: this.state.limb_upper_left ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Upper Left Hand Fingers",
        value: this.state.limb_upper_left_hand_fingers ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Upper Left Arm",
        value: this.state.limb_upper_left_arm ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Lower",
        value: this.state.limb_lower ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Lower Right",
        value: this.state.limb_lower_right ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Lower Right Ankle Foot Toes",
        value: this.state.limb_lower_right_ankle_foot_toes ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Lower Right Leg",
        value: this.state.limb_lower_right_leg ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Lower Left",
        value: this.state.limb_lower_left ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Lower Left Ankle Foot Toes",
        value: this.state.limb_lower_left_ankle_foot_toes ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Lower Left Leg",
        value: this.state.limb_lower_left_leg ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Other",
        value: this.state.symptom_other ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Other Specification",
        value: this.state.symptom_other_specification,
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "2",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics.le_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          const formData =
            RESEARCH_TYPE === "LE Study"
              ? this.props.language === "English"
                ? englishJson
                : this.props.language === "Spanish"
                  ? spanishJson
                  : noLanguageJson
              : englishJson;
          message.success(
            formData.page.demographicQuestions.messages
              .demographicsDataAddedSuccessfully
          );
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(3);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onHandleChangeGeneticStatusList = (e) => {
    let value = e.target.value;
    let tempArr = this.state.gene_list.length > 0 ? this.state.gene_list : [];
    if (this.state.gene_list.includes("Other")) {
      this.setState({
        genetic_status_other_specification: "",
      });
    }
    if (tempArr.includes(value)) {
      let newArray = [];
      for (let item of tempArr) {
        if (item != value) {
          newArray.push(item);
        }
      }
      this.setState({
        gene_list: newArray,
      });
    } else {
      tempArr.push(value);
      this.setState({
        gene_list: tempArr,
      });
    }
  };
  render() {
    const disabledDate = (current) => {
      // Disable all dates after today
      return current && current > moment().subtract(18, "years");
    };
    const formData =
      RESEARCH_TYPE === "LE Study"
        ? this.props.language === "English"
          ? englishJson
          : this.props.language === "Spanish"
            ? spanishJson
            : noLanguageJson
        : englishJson;
    return (
      <div>
        <div className="header">
          <h3 className="text-uppercase">
            {formData.page.demographicQuestions.fields.symptomOnset.innerTitle}
          </h3>
          <div className="white-block"></div>
        </div>
        {this.props.language ? (
          <Spin spinning={this.state.loading}>
            <div className="form-fields">
            <p className="manadatory-note">
              <strong className="text-danger">Note:</strong>
              {formData.page.demographicQuestions.allFieldsMandatory}
            </p>
            <div className="form-group">
              <label className="mb-2 input-heading">
                {
                  formData.page.demographicQuestions.fields.symptomOnset
                    .dateOfDiagnosis
                }
                :
              </label>
              <br />
              <DatePicker
                onChange={(date, dateString) => {
                  let date_of_diagnosis = date;
                  this.setState(
                    {
                      date_of_diagnosis: date,
                    },
                    () => {
                      const currentDate = dayjs(this.state.date_of_birth);
                      const calculatedAge = dayjs(date_of_diagnosis).diff(
                        currentDate,
                        "year"
                      );
                      this.setState({
                        age_at_diagnosis: Math.abs(calculatedAge),
                      });
                    }
                  );
                }}
                format={"MM/YYYY"}
                picker="month"
                value={this.state.date_of_diagnosis}
                placeholder={formData.page.demographicQuestions.fields.personalDetails.placeholders.selectMonth}
                style={{
                  width: "100%",
                  height: 55,
                  maxWidth: 500,
                }}
                disabledDate={(current) => current && current > moment()}
              />
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                {
                  formData.page.demographicQuestions.fields.symptomOnset
                    .ageAtDiagnosis
                }
              </label>
              <br />
              <input
                type="number"
                className="form-control mt-3"
                value={this.state.age_at_diagnosis}
                onChange={(e) =>
                  this.setState({ age_at_diagnosis: e.target.value })
                }
              />
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                {
                  formData.page.demographicQuestions.fields.symptomOnset
                    .dateOfSymptomOnset
                }
                :
              </label>
              <br />
              <DatePicker
                onChange={this.onChange}
                format={"MM/YYYY"}
                picker="month"
                value={this.state.date_of_symptom_onset}
                placeholder={formData.page.demographicQuestions.fields.personalDetails.placeholders.selectMonth}
                style={{
                  width: "100%",
                  height: 55,
                  maxWidth: 500,
                }}
              />
            </div>
            {/* Commented out fields */}
            {/* <div className="form-group">
              <label className="mb-2 input-heading">
                {
                  formData.page.demographicQuestions.fields.symptomOnset
                    .symptomOnsetSite
                }
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({
                    symptom_onset_site: e.target.value,
                  })
                }
                value={this.state.symptom_onset_site}
              >
                <Space direction="vertical">
                  {formData.page.demographicQuestions.fields.symptomOnset.symptomOnsetOptions.map(
                    (option) => (
                      <Radio key={option.value} value={option.value}>
                        {option.label}
                      </Radio>
                    )
                  )}
                </Space>
              </Radio.Group>
            </div> */}
            {/* New Site of Symptom Onset field */}
            <div className="">
              <label className="input-heading mb-0">
                {
                  formData.page.demographicQuestions.fields.symptomOnset
                    .siteOfSymptomOnset
                }
              </label>
            </div>
            <div className="form-group">
              <br />
              <div className="symptom-checkboxs">
                <li>
                  <Checkbox
                    checked={this.state.generalized}
                    onChange={(e) =>
                      this.setState({ generalized: e.target.checked })
                    }
                  >
                    {
                      formData.page.demographicQuestions.fields.symptomOnset
                        .siteOfSymptomOnsetLabels.generalized
                    }
                  </Checkbox>
                </li>
                <div
                  class="form-group mb-4 mt-3"
                  data-field-oid="DMALSF06"
                  data-field-name="new_field876880"
                >
                  <label
                    class="form-label font-weight-bold mb-0"
                    style={{ fontWeight: "800" }}
                  >
                    __________________
                  </label>
                </div>
              </div>
              <br />
              <div className="symptom-checkboxs">
                <li>
                  <Checkbox
                    checked={this.state.bulbar}
                    onChange={(e) =>
                      this.setState({
                        bulbar: e.target.checked,
                        bulbar_speech: false,
                        bulbar_swallowing: false,
                      })
                    }
                  >
                    {
                      formData.page.demographicQuestions.fields.symptomOnset
                        .siteOfSymptomOnsetLabels.bulbar
                    }
                  </Checkbox>
                </li>
                <div style={{ paddingLeft: 25 }}>
                  <li>
                    <Checkbox
                      checked={this.state.bulbar_speech}
                      disabled={this.state.bulbar == true ? false : true}
                      onChange={(e) =>
                        this.setState({ bulbar_speech: e.target.checked })
                      }
                    >
                      {
                        formData.page.demographicQuestions.fields.symptomOnset
                          .siteOfSymptomOnsetLabels.speech
                      }
                    </Checkbox>
                  </li>
                  <li>
                    <Checkbox
                      checked={this.state.bulbar_swallowing}
                      disabled={this.state.bulbar == true ? false : true}
                      onChange={(e) =>
                        this.setState({ bulbar_swallowing: e.target.checked })
                      }
                    >
                      {
                        formData.page.demographicQuestions.fields.symptomOnset
                          .siteOfSymptomOnsetLabels.swallowing
                      }
                    </Checkbox>
                  </li>
                </div>
                <div
                  class="form-group mb-4 mt-3"
                  data-field-oid="DMALSF06"
                  data-field-name="new_field876880"
                >
                  <label
                    class="form-label font-weight-bold mb-0"
                    style={{ fontWeight: "800" }}
                  >
                    ___________________________
                  </label>
                </div>
              </div>

              <div className="symptom-checkboxs">
                <li>
                  <Checkbox
                    onChange={(e) =>
                      this.setState({ neck_weakness: e.target.checked })
                    }
                    checked={this.state.neck_weakness}
                  >
                    {
                      formData.page.demographicQuestions.fields.symptomOnset
                        .siteOfSymptomOnsetLabels.neckWeakness
                    }
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    onChange={(e) =>
                      this.setState({
                        trunk_weakness: e.target.checked,
                      })
                    }
                    checked={this.state.trunk_weakness}
                  >
                    {
                      formData.page.demographicQuestions.fields.symptomOnset
                        .siteOfSymptomOnsetLabels.trunkWeakness
                    }
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    onChange={(e) =>
                      this.setState({ respiratory: e.target.checked })
                    }
                    checked={this.state.respiratory}
                  >
                    {
                      formData.page.demographicQuestions.fields.symptomOnset
                        .siteOfSymptomOnsetLabels.respiratory
                    }
                  </Checkbox>
                </li>

                <div
                  class="form-group mb-4 mt-3"
                  data-field-oid="DMALSF06"
                  data-field-name="new_field876880"
                >
                  <label
                    class="form-label font-weight-bold mb-0"
                    style={{ fontWeight: "800" }}
                  >
                    ___________________________
                  </label>
                </div>
              </div>

              <div className="symptom-checkboxs">
                <li className="pb-1">
                  <Checkbox
                    onChange={(e) =>
                      this.setState({
                        limb: e.target.checked,
                        limb_upper: false,
                        limb_upper_right: false,
                        limb_upper_right_hand_fingers: false,
                        limb_upper_right_arm: false,
                        limb_upper_left: false,
                        limb_upper_left_hand_fingers: false,
                        limb_upper_left_arm: false,
                        limb_lower: false,
                        limb_lower_right: false,
                        limb_lower_right_ankle_foot_toes: false,
                        limb_lower_right_leg: false,
                        limb_lower_left: false,
                        limb_lower_left_ankle_foot_toes: false,
                        limb_lower_left_leg: false,
                      })
                    }
                    checked={this.state.limb}
                  >
                    {
                      formData.page.demographicQuestions.fields.symptomOnset
                        .siteOfSymptomOnsetLabels.limb
                    }
                  </Checkbox>
                </li>
                <li className="pb-1 pl-4">
                  <Checkbox
                    onChange={(e) =>
                      this.setState({
                        limb_upper: e.target.checked,
                        limb_upper_right: false,
                        limb_upper_right_hand_fingers: false,
                        limb_upper_right_arm: false,
                        limb_upper_left: false,
                        limb_upper_left_hand_fingers: false,
                        limb_upper_left_arm: false,
                      })
                    }
                    checked={this.state.limb_upper}
                    disabled={this.state.limb == true ? false : true}
                  >
                    {
                      formData.page.demographicQuestions.fields.symptomOnset
                        .siteOfSymptomOnsetLabels.upper
                    }
                  </Checkbox>
                </li>
                <div style={{ paddingLeft: 25 }}>
                  <li className="pb-1 pl-4">
                    <Checkbox
                      onChange={(e) =>
                        this.setState({
                          limb_upper_right: e.target.checked,
                          limb_upper_right_hand_fingers: false,
                          limb_upper_right_arm: false,
                        })
                      }
                      checked={this.state.limb_upper_right}
                      disabled={this.state.limb_upper == true ? false : true}
                    >
                      {
                        formData.page.demographicQuestions.fields.symptomOnset
                          .siteOfSymptomOnsetLabels.right
                      }
                    </Checkbox>
                  </li>
                  <div style={{ paddingLeft: 25 }}>
                    <li className="pb-1 pl-4">
                      <Checkbox
                        onChange={(e) =>
                          this.setState({
                            limb_upper_right_hand_fingers: e.target.checked,
                          })
                        }
                        checked={this.state.limb_upper_right_hand_fingers}
                        disabled={
                          this.state.limb_upper_right == true ? false : true
                        }
                      >
                        {
                          formData.page.demographicQuestions.fields.symptomOnset
                            .siteOfSymptomOnsetLabels.handFingers
                        }
                      </Checkbox>
                    </li>
                    <li className="pb-1 pl-4">
                      <Checkbox
                        onChange={(e) =>
                          this.setState({
                            limb_upper_right_arm: e.target.checked,
                          })
                        }
                        checked={this.state.limb_upper_right_arm}
                        disabled={
                          this.state.limb_upper_right == true ? false : true
                        }
                      >
                        {
                          formData.page.demographicQuestions.fields.symptomOnset
                            .siteOfSymptomOnsetLabels.arm
                        }
                      </Checkbox>
                    </li>
                  </div>
                  <li className="pb-1 pl-4">
                    <Checkbox
                      onChange={(e) =>
                        this.setState({
                          limb_upper_left: e.target.checked,
                          limb_upper_left_hand_fingers: false,
                          limb_upper_left_arm: false,
                        })
                      }
                      checked={this.state.limb_upper_left}
                      disabled={this.state.limb_upper == true ? false : true}
                    >
                      {
                        formData.page.demographicQuestions.fields.symptomOnset
                          .siteOfSymptomOnsetLabels.left
                      }
                    </Checkbox>
                  </li>
                  <div style={{ paddingLeft: 25 }}>
                    <li className="pb-1 pl-4">
                      <Checkbox
                        onChange={(e) =>
                          this.setState({
                            limb_upper_left_hand_fingers: e.target.checked,
                          })
                        }
                        checked={this.state.limb_upper_left_hand_fingers}
                        disabled={
                          this.state.limb_upper_left == true ? false : true
                        }
                      >
                        {
                          formData.page.demographicQuestions.fields.symptomOnset
                            .siteOfSymptomOnsetLabels.handFingers
                        }
                      </Checkbox>
                    </li>
                    <li className="pb-1 pl-4">
                      <Checkbox
                        onChange={(e) =>
                          this.setState({
                            limb_upper_left_arm: e.target.checked,
                          })
                        }
                        checked={this.state.limb_upper_left_arm}
                        disabled={
                          this.state.limb_upper_left == true ? false : true
                        }
                      >
                        {
                          formData.page.demographicQuestions.fields.symptomOnset
                            .siteOfSymptomOnsetLabels.arm
                        }
                      </Checkbox>
                    </li>
                  </div>
                </div>
                <li className="pb-1 pl-4">
                  <Checkbox
                    onChange={(e) =>
                      this.setState({
                        limb_lower: e.target.checked,
                        limb_lower_right: false,
                        limb_lower_right_ankle_foot_toes: false,
                        limb_lower_right_leg: false,
                        limb_lower_left: false,
                        limb_lower_left_ankle_foot_toes: false,
                        limb_lower_left_leg: false,
                      })
                    }
                    checked={this.state.limb_lower}
                    disabled={this.state.limb == true ? false : true}
                  >
                    {
                      formData.page.demographicQuestions.fields.symptomOnset
                        .siteOfSymptomOnsetLabels.lower
                    }
                  </Checkbox>
                </li>
                <div style={{ paddingLeft: 25 }}>
                  <li className="pb-1 pl-4">
                    <Checkbox
                      onChange={(e) =>
                        this.setState({
                          limb_lower_right: e.target.checked,
                          limb_lower_right_ankle_foot_toes: false,
                          limb_lower_right_leg: false,
                        })
                      }
                      checked={this.state.limb_lower_right}
                      disabled={this.state.limb_lower == true ? false : true}
                    >
                      {
                        formData.page.demographicQuestions.fields.symptomOnset
                          .siteOfSymptomOnsetLabels.right
                      }
                    </Checkbox>
                  </li>
                  <div style={{ paddingLeft: 25 }}>
                    <li className="pb-1 pl-4">
                      <Checkbox
                        onChange={(e) =>
                          this.setState({
                            limb_lower_right_ankle_foot_toes: e.target.checked,
                          })
                        }
                        checked={this.state.limb_lower_right_ankle_foot_toes}
                        disabled={
                          this.state.limb_lower_right == true ? false : true
                        }
                      >
                        {
                          formData.page.demographicQuestions.fields.symptomOnset
                            .siteOfSymptomOnsetLabels.ankleFootToes
                        }
                      </Checkbox>
                    </li>
                    <li className="pb-1 pl-4">
                      <Checkbox
                        onChange={(e) =>
                          this.setState({
                            limb_lower_right_leg: e.target.checked,
                          })
                        }
                        checked={this.state.limb_lower_right_leg}
                        disabled={
                          this.state.limb_lower_right == true ? false : true
                        }
                      >
                        {
                          formData.page.demographicQuestions.fields.symptomOnset
                            .siteOfSymptomOnsetLabels.leg
                        }
                      </Checkbox>
                    </li>
                  </div>
                  <li className="pb-1 pl-4">
                    <Checkbox
                      onChange={(e) =>
                        this.setState({
                          limb_lower_left: e.target.checked,
                          limb_lower_left_ankle_foot_toes: false,
                          limb_lower_left_leg: false,
                        })
                      }
                      checked={this.state.limb_lower_left}
                      disabled={this.state.limb_lower == true ? false : true}
                    >
                      {
                        formData.page.demographicQuestions.fields.symptomOnset
                          .siteOfSymptomOnsetLabels.left
                      }
                    </Checkbox>
                  </li>
                  <div style={{ paddingLeft: 25 }}>
                    <li className="pb-1 pl-4">
                      <Checkbox
                        onChange={(e) =>
                          this.setState({
                            limb_lower_left_ankle_foot_toes: e.target.checked,
                          })
                        }
                        checked={this.state.limb_lower_left_ankle_foot_toes}
                        disabled={
                          this.state.limb_lower_left == true ? false : true
                        }
                      >
                        {
                          formData.page.demographicQuestions.fields.symptomOnset
                            .siteOfSymptomOnsetLabels.ankleFootToes
                        }
                      </Checkbox>
                    </li>
                    <li className="pb-1 pl-4">
                      <Checkbox
                        onChange={(e) =>
                          this.setState({
                            limb_lower_left_leg: e.target.checked,
                          })
                        }
                        checked={this.state.limb_lower_left_leg}
                        disabled={
                          this.state.limb_lower_left == true ? false : true
                        }
                      >
                        {
                          formData.page.demographicQuestions.fields.symptomOnset
                            .siteOfSymptomOnsetLabels.leg
                        }
                      </Checkbox>
                    </li>
                  </div>
                </div>
                <div
                  class="form-group mb-4 mt-3"
                  data-field-oid="DMALSF06"
                  data-field-name="new_field876880"
                >
                  <label
                    class="form-label font-weight-bold mb-0"
                    style={{ fontWeight: "800" }}
                  >
                    ___________________________
                  </label>
                </div>
              </div>

              <div className="symptom-checkboxs">
                <div>
                  <Checkbox
                    checked={this.state.symptom_other}
                    onChange={(e) =>
                      this.setState({
                        symptom_other: e.target.checked,
                        symptom_other_specification: "",
                      })
                    }
                  >
                    {
                      formData.page.demographicQuestions.fields.symptomOnset
                        .siteOfSymptomOnsetLabels.otherPleaseSpecify
                    }
                  </Checkbox>
                </div>
                <div>
                  {this.state.symptom_other == true && (
                    <input
                      type="text"
                      className="form-control mt-3"
                      placeholder={
                        formData.page.demographicQuestions.fields.symptomOnset
                          .siteOfSymptomOnsetLabels.pleaseSpecifyPlaceholder
                      }
                      value={this.state.symptom_other_specification}
                      onChange={(e) =>
                        this.setState({
                          symptom_other_specification: e.target.value,
                        })
                      }
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                {
                  formData.page.demographicQuestions.fields.symptomOnset
                    .phenotype
                }
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({
                    phenotype: e.target.value,
                  })
                }
                value={this.state.phenotype}
              >
                <Space direction="vertical">
                  {formData.page.demographicQuestions.fields.symptomOnset.phenotypeOptions.map(
                    (option) => (
                      <Radio key={option.value} value={option.value}>
                        {option.label}
                      </Radio>
                    )
                  )}
                </Space>
              </Radio.Group>
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                {
                  formData.page.demographicQuestions.fields.symptomOnset
                    .geneticStatus
                }
              </label>
              <br />
              <Select
                onChange={(value) =>
                  this.setState({
                    genetic_status: value,
                    gene_list: [],
                  })
                }
                value={this.state.genetic_status}
                className="col-lg-12"
                style={{
                  width: "100%",
                  height: 55,
                  maxWidth: 500,
                }}
              >
                {formData.page.demographicQuestions.fields.symptomOnset.geneticStatusOptions.map(
                  (option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  )
                )}
              </Select>
              {this.state.genetic_status === "Positive" && (
                <div className="mt-4">
                  <label className="mb-3">
                    {" "}
                    {
                      formData.page.demographicQuestions.fields.symptomOnset
                        .geneFamilyQuestion
                    }
                  </label>
                  <ul>
                    {formData.page.demographicQuestions.fields.symptomOnset.geneticOtherOptions.map(
                      (gene, index) => (
                        <li key={index}>
                          <Checkbox
                            value={gene.value}
                            onChange={this.onHandleChangeGeneticStatusList}
                            checked={this.state.gene_list.includes(gene.value)}
                          >
                            {gene.label}
                          </Checkbox>
                        </li>
                      )
                    )}
                  </ul>
                  {this.state.gene_list.includes("Other") && (
                    <div className="mt-3">
                      <label className="mb-3">
                        {
                          formData.page.demographicQuestions.fields.symptomOnset
                            .otherSpecification
                        }
                        :
                      </label>
                      <br />
                      <div className="col-lg-7 pl-0">
                        <Input
                          value={this.state.genetic_status_other_specification}
                          onChange={(e) =>
                            this.setState({
                              genetic_status_other_specification:
                                e.target.value,
                            })
                          }
                          className="demographics-field-height mb-0"
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save(false)}
                >
                  {formData.page.demographicQuestions.button.saveForLater}
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save(true)}
                >
                  {formData.page.demographicQuestions.button.save}{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                    // background: "#b3b3b3",
                    // cursor: "auto",
                  }}
                  className="submit-button"
                  onClick={() => {
                    this.props.set_active_step(1);
                  }}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  {formData.page.demographicQuestions.button.previous}
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save(false)}
                >
                  {formData.page.demographicQuestions.button.saveForLater}
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save(true)}
                >
                  {formData.page.demographicQuestions.button.savenext}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
            </div>
          </Spin>
        ) : (
          <div className="form-fields">
            <div style={{ textAlign: "center", padding: "50px" }}>
              <Spin size="large" />
            </div>
            <div className="white-block"></div>
          </div>
        )}
      </div>
    );
  }
}
